import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../api/connector'

interface ApplicationInfoArgs {
  organizationUuid: string
  applicationUuid: string
}
interface ApplicationInfoResponse {
  application: {
    name: string
    primary: boolean
  }
}

export async function getApplicationInfo(
  this: ThisConnector,
  { applicationUuid, organizationUuid }: ApplicationInfoArgs
) {
  return this.connector.get(
    `/${organizationUuid}/applications/${applicationUuid}`
  )
}

export const useApplicationInfo = ({ applicationUuid, organizationUuid }) => {
  const { isLoading, error, data } = useContrastQuery<
    ApplicationInfoArgs,
    ApplicationInfoResponse
  >(
    [Query.APPLICATION_INFO, organizationUuid, applicationUuid],
    getApplicationInfo,
    {
      applicationUuid,
      organizationUuid
    }
  )

  return {
    isLoading,
    error,
    data
  }
}
